import { useNavigate } from 'react-router-dom'
import { BsArrowLeftShort } from 'react-icons/bs'
import ephemeraHome from '../Images/ephemeraHome.png'

export default function Ephemera () {

    let navigate = useNavigate()
    const goBack = () => {
        navigate(-1)
    }

    return (
        <div className="project-details">
            <section className="bg-gradient-to-bl from-gray-900 via-gray-800 to-gray-900 dark:bg-gray-900">
                
                <span className="place-self-start mt-5 ml-3">
                    <button className="inline-flex items-center px-4 py-2 mr-3 text-sm font-medium text-gray-400  rounded-lg hover:bg-green-500 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white" id="back-button" onClick={goBack}>
                        <BsArrowLeftShort size={30}/>
                    </button>
                </span>

                <h2 className="mb-4 text-3xl lg:text-4xl tracking-wide font-extrabold text-white text-center dark:text-white">Ephemera</h2>
                <div className="gap-8 items-center pb-8 px-4 mx-auto max-w-screen-xl xl:gap-16 md:grid md:grid-cols-2 sm:py-4 lg:px-6">
                    <img className="w-full dark:hidden" src={ephemeraHome} alt="ephemera"/>

                    <div className="mt-4 md:mt-0">
                        <h4 className="mb-3 text-2xl text-green-400 font-semibold" id="mono-text">Overview</h4>
                        <p className="mb-6 font-light text-gray-200 leading-relaxed md:text-lg dark:text-gray-400">Ephemera is a full-stack app built with React.js, Django, and Django Rest Framework. The app allows users to create and share posts in the form of haiku poems. It incorporates JWT authentication and local storage using  access and refresh tokens. Once logged-in, users have full CRUD capability on posts they create, and they can view the posts of other users.</p>
                        <h4 className="mb-3 text-2xl text-green-400 font-semibold" id="mono-text">Highlights</h4>
                        <div className="mb-4">
                            <li className="mb-1 text-gray-200">Built with React.js, Django & Django Rest Framework</li>
                            <li className="mb-1 text-gray-200">RESTful API & JSON data</li>
                            <li className="mb-1 text-gray-200">JWT Authentication</li>
                            <li className="mb-1 text-gray-200">React UseContext Hook</li>
                            <li className="mb-1 text-gray-200">FlowBite Blocks &  React Components</li>
                            <li className="mb-1 text-gray-200">Axios library for CRUD requests</li>

                        </div>

                        <h4 className="mb-3 text-2xl text-green-400 font-semibold" id="mono-text">Code</h4>
                        <p className="mb-6 font-light text-gray-200 md:text-lg dark:text-gray-400">Click on the button below to view my code for this project on GitHub.</p>
                        <a href="https://github.com/jasondcarmichael/ephemera_daily_haiku" rel="noreferrer noopener" target="_blank" className="inline-flex items-center text-white bg-gray-700 hover:bg-green-500 focus:ring-4 focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:focus:ring-primary-900">
                            GitHub
                            <svg className="ml-2 -mr-1 w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                        </a>
                    </div>
                </div>
            </section>
        </div>
    )
}